export function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

export function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24*60*60*1000*days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

export function deleteCookie(name) { setCookie(name, '', -1); }


export async function hashAndEncodeBase64(spinnerId, Email) {
    const encoder = new TextEncoder();
    const data = encoder.encode(`${spinnerId}|||${Email}`);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data); // hash the data
    const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
    const hashBase64 = btoa(String.fromCharCode(...hashArray)); // convert bytes to base64
    return hashBase64;
}
  

export function getContrast (hexcolor) {
	// If a leading # is provided, remove it
	if (hexcolor.slice(0, 1) === '#') {
		hexcolor = hexcolor.slice(1);
	}

	// If a three-character hexcode, make six-character
	if (hexcolor.length === 3) {
		hexcolor = hexcolor.split('').map(function (hex) {
			return hex + hex;
		}).join('');
	}

	// Convert to RGB value
	var r = parseInt(hexcolor.substr(0,2),16);
	var g = parseInt(hexcolor.substr(2,2),16);
	var b = parseInt(hexcolor.substr(4,2),16);

	// Get YIQ ratio
	var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

	// Check contrast
	return (yiq >= 128) ? 'black' : 'white';
};